import { create } from 'zustand';

import { createFloatingAssistantSlice } from './actions';
import type { FloatingAssistantStore } from './types';

export const useFloatingAssistantStore = create<FloatingAssistantStore>()(
  (set, get, store) => ({
    ...createFloatingAssistantSlice(set, get, store),
  }),
);

export const useIsAssistantHosted = (): boolean =>
  useFloatingAssistantStore((state) => state.hostSlot !== null);

export const useIsAssistantHostReadOnly = (): boolean =>
  useFloatingAssistantStore(
    (state) => state.hostSlot !== null && state.isHostReadOnly,
  );

export const useIsAssistantHostConversationHidden = (): boolean =>
  useFloatingAssistantStore(
    (state) => state.hostSlot !== null && state.isHostConversationHidden,
  );

export type {
  AttachHostArgs,
  BrainPageInputContext,
  DelegateInputContext,
  DoBoxInputContext,
  HostExecutorTarget,
  InputContext,
  InputContextKind,
  ReplyInputContext,
} from './types';
export type { FloatingAssistantStore };
